export interface QuickRepliesState {
  formData: any | null;
  nextResponse: any | null;
}

export const initialQuickRepliesState: QuickRepliesState = {
  formData: null,
  nextResponse: null,
};